<template>
    <div class="tsKampagnenBox">
        <div v-if="suchfeldDetail" class="left">


            <div class="na-fieldset naCol1">



                <h1 class="litName" v-html="suchfeldDetail.LitName">
                </h1>




                <h4 class="na-field-value" v-html="suchfeldDetail.SufDescription">
                </h4>

                <div class="na-field">

                    <div class="sufImg">
                        <img :src="sufImage" class="na-image" />
                    </div>
                </div>

                <div class="na-field-value long-des" v-html="suchfeldDetail.SufLongDescription">
                </div>








            </div>


            <div>
                <div>
                    <DxButton :width="141"
                        
                              class="tsBtnDx"
                              @click="onCancelClick($event)">
                        <i class="dx-icon fa fa-arrow-circle-left"></i>
                        <span class="dx-button-text">
                            Zurück zur Übersicht
                        </span>
                    </DxButton>
                </div>
            </div>
            <!--<div >
                <div>
                    <DxButton :width="120"
                              text="next"

                              class="tsBtnDx"
                              @click="onNextClick($event)" />
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>


    import { DxButton } from 'devextreme-vue/button'
    import $ from 'jquery';


    import '../assets/detailForm.less';

    export default {
        name: 'RssFeedDetail',
        components: {
            DxButton,



        },
        data() {

            return {
                isSaving: false,
                nextSuchfeldId: null

            };
        },
        computed: {
            suchfeldDetail() {
                return this.$store.state.suchfeldStore.suchfeldDetail
            },
            suchfeldDetailIsLoading() {
                return this.$store.state.suchfeldStore.suchfeldDetailIsLoading
            },
            suchfeldDetailText() {
                return JSON.stringify(this.$store.state.suchfeldStore.suchfeldDetail)
            },
            rssSuchfeldList() {
                return this.$store.state.suchfeldStore.rssSuchfeldList
            },
            rssSuchfeldListText() {
                return JSON.stringify(this.$store.state.suchfeldStore.rssSuchfeldList)
            },

            sufImage() {
                return this.$store.state.suchfeldStore.sufImage
            },
            openRoundList() {
                return this.$store.state.roundStore.openRoundList
            },


        },
        props: {
            litId: {
                type: [Number],
                required: true,
                default: 0
            },
        },

        getter: {
            get() {

            },
        },
        created: function () {
            let vm = this
            this.$store.dispatch("getSuchfeldDetail", { litId: vm.litId })
            this.$store.dispatch("getAllRssFeedInfosForSuchfeld", { litId: vm.litId })
            this.$store.dispatch("getOpenRoundListWithSuchfelder")
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=return").submit()
            },
            onNextClick() {
                this.openRoundList;
            }

        }
    }


</script>
<style scoped>
    .litName {
        color: #323740;
       
    }

    template {
        padding-top: 50px;
    }

    h4 {
        color: #717c86;
        max-width:100%
    }

    div {
        text-align: left;
    }

    .sufImg {
        padding-bottom: 30px;
        padding-top: 20px;
        max-width:100%
    }

    .long-des {
        color: black;
    }

    .home {
        margin: 5px;
        display: flex;
        flex-direction: column;
    }

    template {
        background-color: white
    }

    form .na-field .na-field-value {
        max-width: 100%
    }

    .na-field-value-static, .na-field-value:not(.dx-switch):not(.dx-checkbox):not(.dx-button) {
        max-width: 100%
    }
    .na-field {
        max-width: 100%
    }
    .na-fieldset {

    }

    .tsKampagnenBox {
        margin-top: 50px;
        background-color: white;
        padding-left: 30px;
        padding-right: 30px;
        padding-top: 30px;
       width: 50%
    }

    .na-image {
        max-width: 100%
    }

    .tsBtnDx {
        width: 120px;
        background-color: var(--danger-color);
        margin-bottom: 30px;
        margin-top: 30px;
        padding: 1px 2px 2px 2px;
 
    }
   
    h1 {
        padding-bottom: 30px;
    }
</style>


